import React, { useState, useEffect } from 'react';
import {
  Dialog,
  Box,
  Typography,
  Button,
  DialogActions,
} from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface DocumentUploadDialogProps {
  isOpen: boolean;
  docType: string;
  onDateSelected: (date: string, docType: string) => void;
  onClose: () => void;
  requiresDate?: boolean;
}

const DocumentUploadDialog: React.FC<DocumentUploadDialogProps> = ({
  isOpen,
  docType,
  onDateSelected,
  onClose,
  requiresDate = true,
}) => {
  const [localDate, setLocalDate] = useState<Date | null>(null);

  useEffect(() => {
    if (isOpen) {
      setLocalDate(null);
    }
  }, [isOpen]);

  const handleDateChange = (newValue: any) => {
    setLocalDate(newValue);
  };

  const handleConfirm = () => {
    if (localDate) {
      const formattedDate = localDate.toISOString().split('T')[0];
      onDateSelected(formattedDate, docType);

      setTimeout(() => {
        const fileInput = document.getElementById(`${docType}-file`) as HTMLInputElement;
        if (fileInput) {
          fileInput.click();
        }
        onClose();
      }, 150);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          margin: { xs: '10px', sm: '32px' },
          maxWidth: '100%',
          overflowX: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          p: { xs: 1, sm: 2 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ mb: { xs: 1, sm: 2 }, textAlign: 'center', fontWeight: 'bold' }}
        >
          Select Expiry Date
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              transform: { xs: 'scale(0.85)', sm: 'scale(1)' },
              transformOrigin: 'top center',
              mb: { xs: -4, sm: 0 },
            }}
          >
            <DateCalendar 
              value={localDate} 
              onChange={handleDateChange} 
            />
          </Box>
        </LocalizationProvider>
      </Box>

        <DialogActions style={{ display: 'flex', justifyContent: 'center', paddingBottom: '16px' }}>
      
        <Button onClick={onClose} className="custom-cancel-button">
          Cancel
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          className="custom-button"
          disabled={!localDate} 
        >
          Confirm & Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentUploadDialog;